module.exports = __webpack_public_path__ + "images/game/game-start.2a9805b2eddd1c90b31e241182c8252a.png";